module.exports = __webpack_public_path__ + "static/media/wcgPops.7d467305.jpg";